import { createContext, useContext } from 'react';

export const PageIdContext = createContext({
  pageId: null,
  pageRouteId: null,
  isEditing: false,
  pageBasePath: 'pages',
  visibilityMode: null,
  pageVisibilityMode: null,
  allowedCollectionUuids: [],
  allowedFileUuids: [],
});

export const usePageId = () => useContext(PageIdContext).pageId;
export const usePageRouteId = () => {
  const context = useContext(PageIdContext);
  return context.pageRouteId || context.pageId;
};
export const usePageIsEditing = () => useContext(PageIdContext).isEditing;
export const usePageBasePath = () => useContext(PageIdContext).pageBasePath || 'pages';
export const usePageVisibilityMode = () => {
  const context = useContext(PageIdContext);
  return context.visibilityMode || context.pageVisibilityMode || null;
};
export const usePageAllowedCollectionUuids = () => (
  useContext(PageIdContext).allowedCollectionUuids || []
);
export const usePageAllowedFileUuids = () => (
  useContext(PageIdContext).allowedFileUuids || []
);
